import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=0675a7fd&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=tsx&"
export * from "./PageTitle.vue?vue&type=script&lang=tsx&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=0675a7fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675a7fd",
  null
  
)

export default component.exports